import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-add-item-widget',
  templateUrl: './add-item-widget.component.html',
  styleUrls: ['./add-item-widget.component.scss'],
  standalone: false
})
export class AddItemWidgetComponent {

  @Input() icon?: string;
  @Input() message?: string;
  @Input() buttonText?: string;

  @Output() buttonClicked: EventEmitter<any> = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  handleButtonClick() {
    this.buttonClicked.emit();
  }
}
